import React, { useEffect, useState } from "react";
import ArrowBack from "@mui/icons-material/ArrowBack";

import { useRouteMatch, useHistory } from "react-router-dom";
import {
  initPatientDetailsPage,
  cleanUpCurrentPatientInfo,
} from "store/PatientStore/actions";
import { USER_GROUPS } from "constants/roles";
import { AthleteVideoExamTable } from "./containers/Athlete/AthleteVideoExamTable";
import { PatientVideoExamTable } from "./containers/Patient/PatientVideoExamTable";
import { PatientInfoContainer } from "./containers/Patient/PatientInfoContainer";
import { AthleteInfoContainer } from "./containers/Athlete/AthleteInfoContainer";
import { PatientRegionDetails } from "./containers/Patient/PatientRegionDetails";
import { AthleteRegionDetails } from "./containers/Athlete/AthleteRegionDetails";
import { selectCurrentClinician } from "store/ClinicianStore/selectors";
import { selectCurrentPatient } from "store/PatientStore/selectors";
import { useAppSelector, useAppDispatch } from "hooks/reduxHooks";
import ReportModal from "components/ReportModal/ReportModal";
import { uploadLoadTest } from "repositories/patientApi";

const isStaging = window.location.href.includes("staging");
export const PatientDetails = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const match = useRouteMatch<{ id: string }>();
  const isFreeForm = window.location.search.includes("freeForm=true");
  const isFromCronJob = window.location.search.includes("fromCronJob=true");
  const currentClinician = useAppSelector(selectCurrentClinician);
  const currentPatient = useAppSelector(selectCurrentPatient);
  const [reportModalOpen, setReportModalOpen] = useState(false);
  const [isUploading, setIsUploading] = useState(false);

  useEffect(() => {
    dispatch(initPatientDetailsPage(match.params.id));
    return function cleanup() {
      dispatch(cleanUpCurrentPatientInfo());
    };
  }, [match.params.id]);

  const isSuperAdmin = currentClinician?.role?.includes(
    USER_GROUPS.SUPER_ADMIN
  );

  const handleOpenReportModal = () => {
    setReportModalOpen(true);
  };

  const handleCloseReportModal = () => {
    setReportModalOpen(false);
  };

  const handleUploadLoadTest = async () => {
    if (isUploading) return;

    setIsUploading(true);
    console.log("Uploading Load Test for Patient ID:", match.params.id);

    try {
      const payload = { patientId: match.params.id };
      await uploadLoadTest(payload);
      alert("Load test uploaded successfully!");
    } catch (error) {
      console.error("Error uploading load test:", error);
      alert("Failed to upload load test. Please check console for details.");
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="container max-w-[90%] m-auto px-8 pt-[30px]">
      <div className="mb-6">
        <button
          onClick={() => {
            if (window.location.search.includes("from=leaderboard")) {
              history.push("/report/leaderboard");
              return;
            }
            history.push("/");
          }}
          className="flex items-center gap-1 px-4 py-2 bg-sky-400 hover:bg-sky-500 text-white rounded-lg transition-colors"
        >
          <ArrowBack className="w-4 h-4" />
          <span>Back</span>
        </button>
      </div>
      {isSuperAdmin ? (
        <>
          <PatientRegionDetails
            isFromCronJob={isFromCronJob}
            patientId={match.params.id}
          />
        </>
      ) : (
        <>
          {(currentClinician?.role?.includes(USER_GROUPS.CLINICIAN) ||
            currentClinician?.role?.includes(
              USER_GROUPS.CLINIC_TEAM_MEMBER
            )) && (
            <>
              <div className="relative">
                <PatientInfoContainer />
                <div className="absolute bottom-5 left-[120px] flex gap-4">
                  {/*   <button
                    onClick={handleUploadLoadTest}
                    disabled={isUploading}
                    className={`px-4 py-2 text-white rounded-lg transition-colors ${
                      isUploading
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-green-500 hover:bg-green-600"
                    }`}
                  >
                    {isUploading ? "Uploading..." : "Upload Load Test"}
                  </button> */}
                </div>
              </div>
              <PatientRegionDetails
                isFromCronJob={isFromCronJob}
                patientId={match.params.id}
              />
            </>
          )}

          {currentClinician?.role?.includes(USER_GROUPS.COACH) && (
            <>
              <div className="relative">
                <AthleteInfoContainer />
                <div className="absolute bottom-5 left-[120px] flex gap-4">
                  {(currentClinician.llmReportEnabled || !isStaging) && (
                    <button
                      onClick={handleOpenReportModal}
                      className="px-4 py-2 bg-sky-400 hover:bg-sky-500 text-white rounded-lg transition-colors"
                    >
                      View Latest Report
                    </button>
                  )}

                  {isStaging ? (
                    <button
                      onClick={handleUploadLoadTest}
                      disabled={isUploading}
                      className={`px-4 py-2 text-white rounded-lg transition-colors ${
                        isUploading
                          ? "bg-gray-400 cursor-not-allowed"
                          : "bg-green-500 hover:bg-green-600"
                      }`}
                    >
                      {isUploading ? "Uploading..." : "Upload Load Test"}
                    </button>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              {!isFreeForm && <AthleteRegionDetails />}
            </>
          )}

          <div className="w-full card mt-5 rounded-[20px] px-4 pb-7 pt-4">
            <h2 className="text-xl ml-4">Video Exams</h2>
            {currentClinician?.role?.includes(USER_GROUPS.COACH) && (
              <AthleteVideoExamTable isFreeForm={isFreeForm} />
            )}
            {(currentClinician?.role?.includes(USER_GROUPS.CLINICIAN) ||
              currentClinician?.role?.includes(
                USER_GROUPS.CLINIC_TEAM_MEMBER
              )) && <PatientVideoExamTable />}
          </div>
        </>
      )}

      <ReportModal
        open={reportModalOpen}
        onClose={handleCloseReportModal}
        patientName={`${currentPatient?.profileInfo?.firstName || ""} ${
          currentPatient?.profileInfo?.lastName || ""
        }`}
        patientReport={currentPatient?.latestReportText}
        reportDate={currentPatient?.latestReportDate}
      />
    </div>
  );
};
